var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  viewBox: "0 0 16 17",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#27333F",
  d: "M14.25 13.804H1.75a.625.625 0 0 1-.537-.937c.514-.891 1.162-3.14 1.162-5.938a5.625 5.625 0 1 1 11.25 0c0 2.799.649 5.047 1.164 5.938a.625.625 0 0 1-.539.937"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.328 12.55c-.433-.747-1.078-2.86-1.078-5.62a6.25 6.25 0 0 0-12.5 0c0 2.76-.645 4.873-1.079 5.62a1.25 1.25 0 0 0 1.08 1.88h3.187a3.125 3.125 0 0 0 6.124 0h3.188a1.25 1.25 0 0 0 1.078-1.88M8 15.68a1.87 1.87 0 0 1-1.767-1.25h3.534A1.875 1.875 0 0 1 8 15.68m-6.25-2.5C2.352 12.144 3 9.747 3 6.93a5 5 0 0 1 10 0c0 2.816.647 5.212 1.25 6.25z"
})));
export { SvgBellIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/bellIcon.svg";